import {
  addItemAtIndex,
  removeItemAtIndex,
} from '@teetsh/app/src/utils/listMethods';

export default function changeItemIndex<T>(
  list: T[],
  previousIndex: number,
  nIndex: number,
): T[] {
  if (previousIndex >= list.length) {
    return list;
  }

  let newIndex = nIndex;
  if (newIndex < 0) {
    newIndex = list.length - 1;
  } else if (newIndex >= list.length) {
    newIndex = 0;
  }

  const item = list[previousIndex];
  return addItemAtIndex(removeItemAtIndex(list, previousIndex), item, newIndex);
}
